import React from "react";
import styled from "@emotion/styled";
import { AnimatePresence } from "framer-motion";
import PropTypes from "prop-types";

// comps
import StaffCard from "./StaffCard";
import StaffModal from "./StaffModal";

// Style rules
import { Sizes } from "../../styles";

const PeopleGrid = ({ isStaffModalOpen, selectedStaffMember, staffMembers, toggleStaffModal  }) => {
	
	const renderStaffCards = () => {
		return (
			staffMembers &&
			staffMembers.length > 0 &&
			staffMembers.map((staffMember) => {
				return (
					<StaffCard
						key={staffMember.id}
						staffMember={staffMember}
						toggleStaffModal={toggleStaffModal}
					/>
				);
			})
		);
	};
	
	return (
		<>
			<Grid>{renderStaffCards()}</Grid>
			<AnimatePresence>
				{isStaffModalOpen && selectedStaffMember && (
					<StaffModal
						toggleStaffModal={toggleStaffModal}
						staffMember={selectedStaffMember}
					/>
				)}
			</AnimatePresence>
		</>
	);
};

PeopleGrid.propTypes = {
	isStaffModalOpen: PropTypes.bool,
	selectedStaffMember: PropTypes.object,
	staffMembers: PropTypes.array,
	toggleStaffModal: PropTypes.func, 
};

export default PeopleGrid;

const Grid = styled.ul`
	list-style: none;
	padding: unset;
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	grid-auto-rows: auto;
	row-gap: 3rem;
	margin: unset;
	margin-bottom: 4rem;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 4rem 2.4rem;
	}

	@media only screen and (min-width: ${Sizes.screens.large}) {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
`;
